import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from '../../app.settings';
import { BaseGridPage } from '../../core/basepages/allbasepages';
import { Constants } from '../../core/constants';
import { InfoButtonDTO } from '../../models/internal/infobutton-dto';
import { AppGlobalDataService } from '../../services/appglobaldata.service';
import { DataService } from '../../services/data.service';
import { LocalstorageService } from '../../services/localstorage.service';
import { ToastService } from '../../services/toaster/toaster.service';
import { Observable, of } from 'rxjs';
import Helper from '../../core/utility/helper';
import { MatDialog } from '@angular/material/dialog';
import { InfoButtonEditComponent } from '../info-button-edit/info-button-edit.component';

@Component({
  selector: 'app-admin-info-buttons',
  templateUrl: './admin-info-buttons.component.html',
  styleUrls: ['./admin-info-buttons.component.scss']
})
export class AdminInfoButtonsComponent extends BaseGridPage implements OnInit {
  isTeslaCreatedList: any[] = [];
  infoButtonList: InfoButtonDTO[];
  locStorage = Constants.localStorageKeys;

  constructor(
      private dataService: DataService,
      private router: Router,
      private fb: FormBuilder,
      private appGlobalDataService: AppGlobalDataService,
      localstorageService: LocalstorageService,
      logger: NGXLogger,
      private matDialog: MatDialog,
       appSettings: AppSettings,
       private toastService: ToastService
  ) {
      super(localstorageService, logger, appSettings);
  }

  ngOnInit() {
    this.initFilterValues();
      this.fillGrid();
  }
  fillGrid(): void {
      this.filter.Skip = this.skip;
      this.filter.Take = this.pageSize;
      this.getInfoButtons();
  }
  
  onEditClick(infoButtonDTO: InfoButtonDTO) {
    const dialogRef = this.matDialog.open(InfoButtonEditComponent, {
        height: '730px',
        width: '750px',
        data: infoButtonDTO.Id
    });
    dialogRef.afterClosed().subscribe(result => {
       console.log(result);
       this.fillGrid();
    });
}

  getInfoButtons() {
    this.dataService
    .getInfoButtons()
    .subscribe((response: any) => {
        if (response != null) {
            this.infoButtonList = response.Data;
            this.gridView = of({
                data: response.Data,
                total: response.Total ? response.Total : 0,
            });
        }
    });
  }

  Save()
  {

  }
  formatDate(unformattedDate: Date) {
      return Helper.formatDate(unformattedDate);
  }

}
